import { BaseService } from "./../../base";
export class ContrarefService extends BaseService {
  static get entity() {
    return "contraref";
  }
  static get name() {
    return "contrarefs";
  }

  /**
   * Se sobreescribe el "create" para pasar el name 'contraref'
   * @param data
   * @param config
   * @returns {Promise<unknown>}
   */
  static async create(data = {}) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}`, "contraref", data);
  }

  /**
   * Entrega las contrarreferencias que han sido asociadas a una ic
   * @param {int} interconsult_id - el id de la ic de la contrareferencia
   * @returns
   */
  static async getByInterconsultId(interconsult_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_interconsult_id/${interconsult_id}`, "contrarefs");
  }

  /**
   * Entrega las contrareferencias que ha creado un usuario y del establecimiento con el cual ingresó.
   * @param {int} user_id - el id del usuario de la contrareferencia
   * @param {int} node_id - el node_id de la contrareferencia
   * @returns
   */
  static async getByUserAndNode(user_id, node_id, page) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_user_id_node_id/${user_id}/${node_id}?page=${page}`, "contrarefs");
  }

  //Hay que sobreescribir el name
  static async getById(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/${id}`, "contraref");
  }

  /**
   * filtra las contrareferencias con estos campos
   * @param {string} state estado de states_interconsults
   * @param {string} step step de states_interconsults
   * @param {number} node origin_node_id de interconsult
   * @param {number} page paginación
   * @returns
   */
  static async findByStateOriginNodeHas(state, step, node, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_origin_node_id_has/${state}/${step}/${node}?page=${page}`,
      "contrarefs"
    );
  }

  /**
   * filtra las contrareferencias con estos campos
   * @param {string} state estado de states_interconsults
   * @param {string} step step de states_interconsults
   * @param {number} node origin_node_id de interconsult
   * @param {number} page paginación
   * @returns
   */
  static async findByStateOriginNodeDoesntHas(state, step, node, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state_origin_node_id_doesnthave/${state}/${step}/${node}?page=${page}`,
      "contrarefs"
    );
  }

  /**
   * Entrega las contrareferencias según estado y step de state_interconsult, el nodo de origen de la interconsulta.
   * @param {int} state - el state de state_interconsult
   * @param {int} step - el step de state_interconsult
   * @param {int} node_id - el origin_node_id de interconsult
   * @param {int} page - paginación
   * @returns
   */
  static async getByStateOriginNode(state, step, node_id, page = 1) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}contrarref/find_by_state_origin_node_id/${state}/${step}/${node_id}?page=${page}`,
      "contrarefs"
    );
  }

  /**
   *
   * @param {Object} data
   * Se envian los siguientes parametros como objeto
   * date_start:2021-05-04
   * date_end:2021-05-28
   * service_id: 11
   * medic_id: 1
   * @returns
   */
  static async getFilterByMonthly(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/rpt_filter_by_monthly`, this.name, data);
  }
  /**
   *
   * @param {Object} data
   * Se envian los siguientes parametros como objeto
   * date_start:2021-05-04
   * date_end:2021-05-28
   * service_id: 11
   * medic_id: 1
   * @returns
   */
  static async getFilterByYearly(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/rpt_filter_by_yearly`, this.name, data);
  }
  /**
   * Retorna el listado de contrarefs según el filtro en la búsqueda (Esta API se utiliza en Reporte de contrarefs)
   * @param {object} data
   * @param {int} page
   * @returns
   */
  static async getRptByDetail(data, page = 1) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}contraref/rpt_filter_by_detail?page=${page}`, "contrarefs", data);
  }

  static async getRptByDetailExport(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}contraref/rpt_filter_by_detail_export`, null, data, {
      responseType: "blob",
    });
  }
}
